import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import AdminShell from "@/components/AdminShell";

const ROLE_STYLE = {
  admin: "bg-plum text-cream",
  moderator: "bg-teal/15 text-teal-dark",
  member: "bg-rose/40 text-plum",
};

export default function AdminMembers() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");

  const load = useCallback(() => {
    const p = new URLSearchParams();
    if (q) p.set("q", q);
    api.get(`/admin/members?${p.toString()}`).then((r) => setRows(r.data)).catch(() => {});
  }, [q]);

  useEffect(() => { load(); }, [load]);

  return (
    <AdminShell active="members" title="Members" subtitle="Everyone in the Circle (read-only).">
      <input data-testid="mem-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search name or email…"
        className="w-full sm:max-w-md rounded-full border border-rose/40 px-4 py-2.5 text-sm mb-5 focus:outline-none focus:ring-2 focus:ring-teal/40" />

      <div className="overflow-hidden rounded-2xl border border-rose/30 bg-white" data-testid="mem-table">
        <table className="w-full text-sm">
          <thead className="bg-rose-soft text-plum text-left">
            <tr><th className="px-4 py-3">Name</th><th className="px-4 py-3 hidden sm:table-cell">Email</th><th className="px-4 py-3">Role</th><th className="px-4 py-3 hidden md:table-cell">Signup</th></tr>
          </thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={4} className="px-4 py-6 text-mutedplum">No members found.</td></tr>}
            {rows.map((m) => (
              <tr key={m.user_id} className="border-t border-rose/20" data-testid={`mem-${m.user_id}`}>
                <td className="px-4 py-3 text-plum font-medium">{m.name}</td>
                <td className="px-4 py-3 text-mutedplum hidden sm:table-cell">{m.email}</td>
                <td className="px-4 py-3"><span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${ROLE_STYLE[m.role] || "bg-rose/40 text-plum"}`}>{m.role}</span></td>
                <td className="px-4 py-3 text-mutedplum hidden md:table-cell">{(m.created_at || "").slice(0, 10)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </AdminShell>
  );
}
